import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
export const Root = styled(Box)({
  position: 'relative',
  margin: 'auto'
});
export const Frame = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});
export const Value = styled(Typography)(({
  theme,
  compact
}) => ({
  color: theme.palette.grey[700],
  ...spreadTypography(theme.typography[compact ? 'Lato Emphasized 1' : 'Lato H4 Bold'])
}));
const LabelRoot = styled(Typography)(({
  theme
}) => ({
  color: theme.palette.grey[600]
}));
export const Label = withDefaults(LabelRoot, {
  variant: 'Lato Caption Small'
});
export const Progress = styled('svg')({
  position: 'absolute',
  transform: 'rotate(-90deg)'
});
export const CircleBack = styled('circle')(({
  theme
}) => ({
  fill: 'none',
  stroke: theme.palette.grey[300],
  strokeLinecap: 'round'
}));
export const CircleFront = styled('circle')(({
  theme
}) => ({
  fill: 'none',
  stroke: theme.palette.primary.main,
  strokeLinecap: 'round',
  transition: 'stroke-dashoffset ease-in-out 500ms'
}));